import React, {Component} from 'react';
import MDSpinner from "react-md-spinner";
import { FormattedDate, FormattedNumber } from 'react-intl';
import Displaymap from './Displaymap.js';
import GetDocDetails from './GetDocDetails.js';
//import docDocument from './images/document.png';
import pdfDocImage from './images/docPDF.png';
//import xlsImage from './images/docXLS.png';
//import docImage from './images/docImage.png';
//import docWord from './images/docWord.png';
//import { isNullOrUndefined } from 'util';

var JsonFileDiv = document.createElement("DIV");
JsonFileDiv.setAttribute("id", "JsonFile");
document.getElementsByTagName('body')[0].appendChild(JsonFileDiv);

let pssParams = window.pss_params;

let apiURL = document.location.host;
//let apiURL = 'localhost/RiverCity';

let presales_site_url = 'demos-sp-ocl-ug';
let presales_site_master = 'DEMO_NSW';
let presales_site_compliance = 'DEMO_NSW';
let presales_site_request = 'DEMO_NSW';
let presales_site_portal_name = 'PRONLINESERVICE';
let presales_site_portal_suite = 'PR';
let presales_site_asset_register = 'ASSET';

if (pssParams) {
    presales_site_url = pssParams.presales_site_url;
    presales_site_master = escape(pssParams.presales_site_master);
    presales_site_compliance = escape(pssParams.presales_site_compliance);
    presales_site_request = escape(pssParams.presales_site_request);
    presales_site_portal_name = escape(pssParams.presales_site_portal_name);
    presales_site_portal_suite = escape(pssParams.presales_site_portal_suite);
    presales_site_asset_register = escape(pssParams.presales_site_asset_register);
}

let appGetDetails = `https://${apiURL}/wp-json/presalessettings/v1/fetchapplicationdetails/`;
//let docGetIDURL = `https://${apiURL}/wp-json/presalessettings/v1/fetchecmindexitems/`;
//let docViewURL = `https://${presales_site_url}.t1cloud.com/T1Default/CiAnywhere/Web/${presales_site_url.toUpperCase()}/Api/CMIS/T1/content/`;
let myData = [];

class DisplayApplication extends Component {
    constructor(props) {
        super(props);
        this.state = {
            myID: '',
            appData: [],
            appCost: '',
            applicant: '',
            builder: '',
            appProgress: [],
            appDocumentList: [],
            isLoading: false,
            error: null,
            myCurrency: "AUD",
            formattedType: "currency",
            mapInfo: {},
            propertyInfo: {}
        }
    }

    componentDidMount () {
        //console.log(JSON.stringify(this.props));
        this.myID = this.props.appDetailsID;
        this.setState({isLoading: true});
        //console.log(this.myID);
        this._getAllData();
    }

    componentWillReceiveProps (newProps) {
        this.myID = newProps.appDetailsID;
        this.setState({isLoading: true});
        this.setState({appProgress: []});
        this.setState({appDocumentList: []});
        this._getAllData();
    }

    applicationDisplay(appJson) {
        // use this line to display the Json we got back for testing / verification
        if (appJson !== '') {
            document.getElementById("JsonFile").innerHTML = "<pre>" + JSON.stringify(appJson, 0, 4) + "</pre>";
        } else {
            document.getElementById("JsonFile").innerHTML = "<pre></pre>";
        }
    }

    render () {
        const {isLoading, error} = this.state;

        if (error) {
            return <div>{error.message}</div>;
        }
        
        if (isLoading) {
            return <div className="MDloading"><MDSpinner size={75} /></div>;
        }

        return (
            <div className="">
                <div className="atSection">
                    <div className = "atSectionHeading">
                        
                    </div>
                    <h2 className="">
                        {myData.FileId}
                    </h2>
                </div>
                <div className="atSection atType">
                    <div className="atSectionHeading">
                        Type
                    </div>
                    <div className="atSectionValue">
                        {myData.ApplicationType_Desc}
                    </div>
                </div>
                <div className="atSection atDescription">
                    <div className="atSectionHeading">
                        Description
                    </div>
                    <div className="atSectionValue">
                        {myData.Description}
                    </div>
                </div>
                <div className="atSection atLocation">
                    <div className="atSectionHeading">
                        Location
                    </div>
                    <div className="atSectionValue">
                        {myData.SiteName}
                    </div>
                </div>
                <div className="atSection atLocation">
                    <div className="atSectionHeading">
                        Map Location
                    </div>
                    <div id="map">
                        <Displaymap mapDetails = {this.state.mapInfo} propDetails = {this.state.propertyInfo} />
                    </div>
                </div>
                <div className="atSection atCost">
                    <div className="atSectionHeading">
                        Cost
                    </div>
                    <div className="atSectionValue">
                        {this.state.appCost > 0 ? (<FormattedNumber value={this.state.appCost} style={this.state.formattedType} currency={this.state.myCurrency} />) : ("$0")}
                    </div>
                </div>
                <div className="atSection atLodgedDate">
                    <div className="atSectionHeading">
                        Lodged Date
                    </div>
                    <div className="atSectionValue">
                        {myData.LodgedDate ? (<FormattedDate day='2-digit' month='long' year='numeric' value={myData.LodgedDate} />) : ("No Date")}
                    </div>
                </div>
                <div className="atSection atAcceptedDate">
                    <div className="atSectionHeading">
                        Accepted Date
                    </div>
                    <div className="atSectionValue">
                        {myData.AcceptedDate ? (<FormattedDate day='2-digit' month='long' year='numeric' value={myData.AcceptedDate} />) : ("No Date")}
                    </div>
                </div>
                <div className="atSection atDeterminedDate">
                    <div className="atSectionHeading">
                        Determined Date
                    </div>
                    <div className="atSectionValue">
                        {myData.DecisionDate ? (<FormattedDate day='2-digit' month='long' year='numeric' value={myData.DecisionDate} />) : ("No Date")}
                    </div>
                </div>
                <div className="atSection atApplicant">
                    <div className="atSectionHeading">
                        Applicant(s)
                    </div>
                    <div className="atSectionValue">
                        {this.applicant ? (this.applicant) : ("None Listed")}
                    </div>
                </div>
                <div className="atSection atOtherPerson">
                    <div className="atSectionHeading">
                        Applicant Builder(s)
                    </div>
                    <div className="atSectionValue">
                        {this.builder ? (this.builder) : ("None Listed")}
                    </div>
                </div>
                <div className="atSection atProgress">
                    <div className="atSectionHeading">
                        Progress
                    </div>
                    <div className="atSectionValue">
                    {this.state.appProgress.reverse().map(([key, myDate, myValue]) => 
                        <div key= {key} className = "atProgressLine">
                            <div className = "atProgressDate">
                                {myDate ? (<FormattedDate day='2-digit' month='long' year='numeric' value={myDate} />) : ("No Date")}
                            </div>
                            <div className = "atProgressTitle">
                                {myValue}
                            </div>
                        </div>
                    )}
                    </div>
                </div>
                <div className="atSection atProgress">
                    <div className="atTimeline">
                        Timeline
                    </div>
                    <section className="timeline">
                        <ul>
                        <div className="now">Now</div>
                        {this.state.appProgress.map(([key, myDate, myValue]) =>
                        <li key={key}>
                            <div>
                                <time>
                                    {myDate ? (<FormattedDate day='2-digit' month='long' year='numeric' value={myDate} />) : ("No Date")}
                                </time>
                                    {myValue}
                            </div>
                        </li>
                        )}
                        </ul>
                    </section>
                </div>
                <div className="atSection atDocument">
                    <div className="atSectionHeading">
                        Related Documents
                    </div>
                    {this.state.appDocumentList.length !== 0 ? (<div className="atSectionValue">
                    {this.state.appDocumentList.map(([key, docLabel, thisdocid, docimage]) => 
                        <div key= {key} className = "atProgressLine">
                            {<GetDocDetails docid = {thisdocid} label = {docLabel} image = {docimage}/>}
                        </div>
                    )}
                    </div>) : (<div className="atSectionValue"><div className = "atProgressLine"><div className = "atProgressTitle">No Documents</div></div></div>)}
                </div>
                <div>&nbsp;</div>
            </div>
            
        );
    }

    // need to be looping through ApplicationAttachments
    async _getAllData() {
        fetch(appGetDetails + this.myID).then(response => {
            let contentType = response.headers.get("Content-Type");
            if (contentType && contentType.includes("application/json")) {
                return response.json();
            }
            throw new TypeError("Oops, we haven't got JSON!");
        }).then(json => {
            //this.applicationDisplay(json);
/*             let xmlData = JSON.stringify(json, ['ApplicationData'],4);
            xmlData = JSON.parse(xmlData); */
            //console.log(xmlData.ApplicationData);

            let appFields = JSON.stringify(json, ['FileId', 'ApplicationType_Desc', 'Description', 'SiteName', 'Value', 'LodgedDate',
            'AcceptedDate', 'DecisionDate'], 4);
            myData = JSON.parse(appFields);
           
            let mapFields = JSON.stringify(json, ["Map", "MapId", "LocationId", "CategoryLabel", "Centroid", "Latitude", "Longitude", "MapLayers", "Description", "LayerColour", "Geometries", "MapKey", "WKT"], 8);
            let mapInfo = JSON.parse(mapFields);

            let propertyFields = JSON.stringify(json, ["Map", "MapLayers", "Polygons", "PolygonPoints", "Latitude", "Longitude"], 8);
            let propertyInfo = JSON.parse(propertyFields);

            // get cost
            let costFields = JSON.stringify(json, ["CustomFieldsList", "EntityCode2", "Value"], 4);
            let costValues = JSON.parse(costFields);

            //loop through JSON and get cost
            Object.keys(costValues).forEach((key) => {
                Object.keys(costValues[key]).map((keys) => {
                    if (costValues[key][keys].EntityCode2 === "COSTOFWORK" && costValues[key][keys].Value !== '') {
                        //console.log(costValues[key][keys].Value);
                        this.setState ({
                            appCost: costValues[key][keys].Value
                        })
                        //this.state.appCost = costValues[key][keys].Value;
                        return this.state.appCost;
                    }
                    return this.state.appCost;
                });
            });

            // get applicants
            let applicantFields = JSON.stringify(json, ["AssociationList", "AssociationTypeDescription", "LinkedEntityIdDescription"], 4);
            let applicantValues = JSON.parse(applicantFields);

            //loop through JSON and get applicants
            Object.keys(applicantValues).forEach((key) => {
                Object.keys(applicantValues[key]).map((keys) => {
                    //console.log(applicantValues[key][keys]);
                    if (applicantValues[key][keys].AssociationTypeDescription === "Application Applicant") {
                        this.applicant = applicantValues[key][keys].LinkedEntityIdDescription;
                        return this.applicant;
                    } else if (applicantValues[key][keys].AssociationTypeDescription === "Application Builder") {
                        this.builder = applicantValues[key][keys].LinkedEntityIdDescription;
                    }
                    return this.applicant;
                });
            });

            //get application progress
            let appProgressFields = JSON.stringify(json, ["ApplicationStreamList", "StreamTypeDescription", "Description", "DateEffective", "Attachments", "AttachmentLabel", "AttachmentFileName", "Lines", "DownloadUrl", "SecureStoreDocSetId", "Vers"], 4);
            let appProgressValues = JSON.parse(appProgressFields);
            //console.log(json);
            //this.applicationDisplay(appProgressValues);
            
            let counter = 0;

            Object.keys(appProgressValues).forEach((key) => {
                Object.keys(appProgressValues[key]).map((keys) => {
                    //console.log(appProgressValues[key][keys].DateEffective + " - " + appProgressValues[key][keys].Description);
                    if (appProgressValues[key][keys].DateEffective && appProgressValues[key][keys].Description) {
                        //console.log(this.state.appProgress.length, appProgressValues[key][keys].DateEffective + " - " + appProgressValues[key][keys].Description);
                        this.state.appProgress.push([counter++, appProgressValues[key][keys].DateEffective, appProgressValues[key][keys].Description]);
                    }
                    return this.appProgress;
                });
            });

            this.state.appProgress.reverse();

            //get application documents
            let appDocuments = JSON.stringify(json, ["Attachments", "AttachmentLabel", "AttachmentFileName", "Lines", "DownloadUrl", "SecureStoreDocSetId", "Vers"], 4);
            let appDocumentValues = JSON.parse(appDocuments);
            let docCounter = 0;

            //console.log(json);
            Object.keys(appDocumentValues.Attachments).forEach((key) => {
                Object.keys(appDocumentValues.Attachments[key]).map((keys) => {
                    let thisDocID = appDocumentValues.Attachments[key][keys].SecureStoreDocSetId;
                    let extImage = pdfDocImage;
                    if (appDocumentValues.Attachments[key][keys].SecureStoreDocSetId !== 0) {
                        this.state.appDocumentList.push([docCounter++, appDocumentValues.Attachments[key][keys].AttachmentLabel, thisDocID, extImage]);
                    }
                    return true;
                });
                return true;
            });

            //console.log(this.state.appDocumentList.length);
            // leave this to refresh display....anything after isn't called in time
            this.setState ({
                appData: myData,
                isLoading: false,
                mapInfo: mapInfo,
                propertyInfo: propertyInfo,
            });
    }).catch(error => this.setState({error, isLoading: false}));
        return
    }
}
export default DisplayApplication;


// WEBPACK FOOTER //
// ./src/DisplayApplication.js